// Native
import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'input-icon',
  templateUrl: './input-icon.component.html'
})
export class InputIconComponent implements OnInit {

  @Input() placement: 'left' | 'right' = 'left';

  constructor() {}

  ngOnInit() {
  }
}
